export const SET_TAB_INDEX = "SET_TAB_INDEX_SETTINGS"